import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import LeaderUserContainer from '../../../features/page/copyTrading/leader/LeaderUserContainer'
import LeaderInfoContainer from '../../../features/page/copyTrading/leader/LeaderInfoContainer'
import LeaderCopierContainer from '../../../features/page/copyTrading/leader/LeaderCopierContainer'
import {useSearchParams} from 'react-router-dom'
import useQueryLeaderDetail from '../../../hooks/api/leader/useQueryLeaderDetail'
import LeaderGraphContainer from '../../../features/page/copyTrading/leader/LeaderGraphContainer'
import RawJsonContainer from '../../../components/layout/RawJsonContainer'

interface IProps {
    className?: string
}

// 이 페이지는 admin 엔드포인트만 사용한다 — admin/copy/leader/:id, admin/leader/graph/:id.
// 리더 자산/포지션과 카피어별 정산 정보는 admin API가 제공하지 않아 빠져 있다
// (백엔드 요청 내역: docs/admin-copy-api-requests.md).
const CopyLeaderDetailPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryId = searchParams.get('id')

    const {data: leaderDetail} = useQueryLeaderDetail(queryId)

    return (
        <PageLayout title={'Copy Leader Detail'} className={`space-y-[30px] ${className}`}>
            <LeaderUserContainer leaderDetail={leaderDetail} />
            <LeaderInfoContainer leaderDetail={leaderDetail} />
            <LeaderCopierContainer leaderDetail={leaderDetail} />
            <LeaderGraphContainer leaderId={queryId} />
            <RawJsonContainer title={'admin/copy/leader/:id (Raw)'} data={leaderDetail as any} />
        </PageLayout>
    )
}

export default CopyLeaderDetailPage
